// extracted by mini-css-extract-plugin
export default {"txt01":"add-update-widget_txt01__pXvyc","border":"add-update-widget_border__iY+Oa"};